import gql from 'not-graphql-tag';

export const getAllOutageEvents = gql`
  query getAllOutageEvents {
    getAllOutageEvents
  }
`;

export const getAccountDetails = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
    $commPreferencesParams: CommPreferencesParams!
  ) {
    getAccountDetails(params: $params) {
      accountNumber
      isDefault
      description
      accountType
      isActive
      encryptedPersonId
      mainCustomerName
      serviceConnectivity {
        isDisconnected
        isEligibleForReconnect
        disconnectionDate
      }
      premiseInfo {
        isEligibleForOutage
        encryptedPremiseId
        addressLine1
        addressLine2
        state
        city
        postal
        houseType
        servicePointDetails {
          encryptedServicePointId
          lat
          long
          outageInfo {
            isReported
            totalReports
            crewDispatchStatus
            callbackPhone
            estimatedTimeOn
            estimatedTimeOut
            hasKnownOutage
            isDueToStorm
            callbackRequested
            registeredPhone
            isReported
            customersAffected
            cause
            eventStatus
          }
          meter {
            status
          }
        }
      }
      commPreferences(commPreferencesParams: $commPreferencesParams) {
        notificationType
        deliveryTypeDetails {
          deliveryType
          contactDetails {
            contactId
            encryptedContactId
            value
            encryptedPreferenceId
            isSelected
          }
        }
      }
    }
  }
`;

export const getAccountNotificationsDetails = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
    $commPreferencesParams: CommPreferencesParams!
  ) {
    getAccountDetails(params: $params) {
      accountNumber
      premiseInfo {
        encryptedPremiseId
        servicePointDetails {
          encryptedServicePointId
          outageInfo {
            callbackPhone
            callbackRequested
          }
        }
      }
      commPreferences(commPreferencesParams: $commPreferencesParams) {
        deliveryTypeDetails {
          deliveryType
          contactDetails {
            contactId
            encryptedContactId
            encryptedPreferenceId
            value
            isSelected
          }
        }
      }
    }
  }
`;

export const getAllPlannedOutageEvents = gql`
  query GetAllPlannedOutageEvents {
    getAllPlannedOutageEvents {
      totalNoOfPlannedOutages
      plannedOutageEvents {
        parentActivityId
        eventId
        lat
        long
        totalCustomersImpacted
        estimatedTimeOut
        estimatedTimeOn
      }
    }
  }
`;

export const getAccountPlannedOutageEvents = gql`
  query GetAccountPlannedOutageEvents($input: AccountPlannedOutageEventsInput) {
    getAccountPlannedOutageEvents(input: $input) {
      accountPlannedOutageEvent {
        eventId
        estimatedTimeOut
        duration
        eventStatus
      }
    }
  }
`;

export const getOutagesByCountyOrZipCode = gql`
  query GetOutagesByCountyOrZipCode($params: OutageSpecificInput) {
    getOutagesByCountyOrZipCode(params: $params) {
      ... on OutageDetailsByCountyList {
        outageByCountyList {
          zipCodeInfo {
            zipCode
            lat
            long
            outages
            totalCustomersEffected
          }
        }
        typeName
      }
    }
  }
`;
